export default "__VITE_ASSET__CkUwBap8__"